import React, {Component} from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import PropTypes from "prop-types";
import {Strings} from "./Strings";

export class DisclaimerModal extends Component {
    render() {
        const shouldShow = !this.props.isAccepted;
        return <Modal isOpen={shouldShow} size="lg">
            <ModalHeader>Legal Notice & Disclaimer</ModalHeader>
            <ModalBody>
                <p>
                    <u>Ownership</u><br/>
                    This application is owned by AVK Holding A/S, DK-8464 Galten, DENMARK - CVR 44782510 (company
                    registration number) and has been made in accordance with Danish law.
                </p>
                <p>
                    <u>Use</u><br/>
                    This application is mean to provide certain information as to the activities of AVK Holding A/S, its
                    subsidiaries and affiliated companies. Please read this Disclaimer and the Privacy Policy before
                    using this application. By using this application you accept the terms and conditions set out below
                    and consent to the Privacy Policy.
                </p>
                <p>
                    <u>Content</u><br/>
                    AVK Holding A/S strives to continuously update this application. However, we disclaim any and all
                    liability that may ensue from errors or omissions in, or inaccessibility to, the application and may
                    discontinue distributing the application without prior notice. The information on this application
                    is intended for general guidance only and AVH Holding A/S shall have no liability with respect of
                    calculations provided through this application. We encourage users to seek further specification
                    advice through either the local AVK subsidiary or through engineering consulting services.
                </p>
                <p>
                    <u>Liability</u><br/>
                    Your use of this application is at your own risk. AVK Holding A/S does not warrant that the software
                    used for this application, and the information, or any other services provided by means of this
                    application are error-free, or that their use will be uninterrupted.
                </p>
                <p>
                    <u>DISCLAIMER</u><br/>
                    THE CONTENT AND CALCULATIONS PROVIDED BY THIS APPLICATION ARE PROVIDED “AS IS”. AVK HOLDING A/S
                    EXPRESSLY DISCLAIMS ALL WARRANTIES RELATED TO SAID CONTENT INCLUDING, WITHOUT LIMITATION, THOSE OF
                    ACCURACY, CONDITION, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. NEITHER AVK HOLDING A/S
                    NOR ITS AFFILIATES SHALL BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT OR PUNITIVE
                    DAMAGES ARISING OUT OF ACCESS TO OR USE OF ANY CONTENT ON THIS APPLICATION INCLUDING VIRUSES, REGARDLESS OF
                    THE ACCURACY OR COMPLETENESS OF ANY SUCH CONTENT.
                </p>
                <p>
                    <u>Comments</u><br/>
                    Any comments sent to AVK Holding A/S regarding this application become the property of AVK Holding
                    A/S and may be used without limitation. Received comments will not be treated as confidential.
                </p>
                <p>
                    <u>Updates</u><br/>
                    AVK Holding A/S reserves the unilateral right to update, modify, change and alter its Legal Notice
                    and Disclaimer and Privacy Policy at any time. All such updates, modifications, changes and alterations
                    are binding on all users of this application and will be posted here.
                </p>
                <p>
                    <u>Choice of law and venue</u><br/>
                    This Disclaimer & Legal Notice shall be governed by Danish Law without regard to its conflict of law
                    rules. Any dispute arising out of or in relation to this Legal Notice and Disclaimer and Privacy
                    Policy, which cannot be solved amicably, shall be decided by the Danish Courts.
                </p>
                <p>
                    <u>Intellectual Property Rights</u><br/>
                    All materials on in this application and the content generated by this application is subject to
                    copyright, trademark and other intellectual property rights protection under national and
                    international laws. Names, signs and logos in this application are protected trademarks or trade names. Nothing
                    contained in this application should be construed as granting any license or right to use any
                    trademark displayed in the application without prior written permission of AVK Holding A/S.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button onClick={this.props.onAccept} color="primary">{Strings.buttonAccept}</Button>
            </ModalFooter>
        </Modal>
    }
}

DisclaimerModal.propTypes = {
    onAccept: PropTypes.func.isRequired,
    isAccepted: PropTypes.bool.isRequired
};